export enum SupportEmail {
  NURSING_HOME = 'support@pflegenavi.at',
  SERVICE_PROVIDER = 'support@pflegenavi.at',
  FAMILY_MEMBER = 'help@pflegenavi.at',
}
